(() => {
  const selector = '[data-techtic-float-widget]';
  let lazyObserver;

  const markReady = (node) => {
    if (node.querySelector('.float-product-listing, .float-product-details, .float-cart')) {
      node.classList.add('is-float-ready');
      return true;
    }
    return false;
  };

  const loadWidget = (node) => {
    if (!node || node.dataset.floatLoading === 'true' || node.classList.contains('is-float-ready')) return;
    const source = node.dataset.floatUrl;
    if (!source) return;

    node.dataset.floatLoading = 'true';
    const renderedWidget = new MutationObserver(() => {
      if (markReady(node)) renderedWidget.disconnect();
    });
    renderedWidget.observe(node, { childList: true, subtree: true });

    const script = document.createElement('script');
    script.async = true;
    script.src = source;
    script.addEventListener('error', () => {
      renderedWidget.disconnect();
      node.dataset.floatLoading = 'false';
      node.classList.add('has-float-error');
    }, { once: true });
    node.appendChild(script);
  };

  const observeWidget = (node) => {
    if (node.dataset.techticFloatWidget === 'collection' && 'IntersectionObserver' in window) {
      if (!lazyObserver) {
        lazyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            lazyObserver.unobserve(entry.target);
            loadWidget(entry.target);
          });
        }, { rootMargin: '500px 0px' });
      }
      lazyObserver.observe(node);
      return;
    }
    loadWidget(node);
  };

  const scan = (root = document) => {
    if (root.matches?.(selector)) observeWidget(root);
    root.querySelectorAll?.(selector).forEach(observeWidget);
  };

  const start = () => {
    scan();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
